const INTENT_KEY = "cre_login_intent";

/** @typedef {"extension" | "enterprise"} CreLoginIntent */

/** @param {CreLoginIntent} intent */
export function setCreLoginIntent(intent) {
  try {
    sessionStorage.setItem(INTENT_KEY, intent);
  } catch {
    /* ignore */
  }
}

/** @returns {CreLoginIntent | null} */
export function getCreLoginIntent() {
  try {
    const v = sessionStorage.getItem(INTENT_KEY);
    return v === "extension" || v === "enterprise" ? v : null;
  } catch {
    return null;
  }
}

export function clearCreLoginIntent() {
  try {
    sessionStorage.removeItem(INTENT_KEY);
  } catch {
    /* ignore */
  }
}

/** @param {CreLoginIntent} intent */
export function peekOrSetCreLoginIntent(intent) {
  const existing = getCreLoginIntent();
  if (existing) return existing;
  setCreLoginIntent(intent);
  return intent;
}
